import { notifier } from "../../core/notifier/notifier";
import { translator } from "../../translation/translator";
import type { DashboardApi } from "./dashboard-api";
import type { DashboardForm, DashboardGranularity } from "./dashboard-form";
import type { DashboardRender } from "./dashboard-render";

export class DashboardHandler {
    private readonly form: DashboardForm;

    private readonly api: DashboardApi;

    private readonly render: DashboardRender;

    private granularity: DashboardGranularity = "daily";

    public constructor(form: DashboardForm, api: DashboardApi, render: DashboardRender) {
        this.form = form;
        this.api = api;
        this.render = render;
    }

    public async bootstrap(): Promise<void> {
        await this.load();
    }

    public handleGranularityChange(value: DashboardGranularity, button: HTMLButtonElement): void {
        if (value === this.granularity) {
            return;
        }

        this.granularity = value;
        this.form.getGranularityButtons().forEach((btn) => {
            btn.classList.toggle("is-active", btn === button);
        });

        void this.load();
    }

    private async load(): Promise<void> {
        const statusEl = this.form.getStatusEl();
        if (statusEl) {
            statusEl.textContent = "";
        }

        try {
            const stats = await this.api.fetchStats(this.granularity);
            this.render.renderStats(this.form.getStatEls(), stats);
            this.render.renderDiffs(this.form.getDiffEls(), stats);
            this.render.renderCharts(this.form.getChartCanvases(), stats, (canvas) =>
                this.form.getChartLegendElement(canvas),
            );
            this.render.renderStatusLinks(this.form.getStatusLinksLists(), stats);
            this.render.renderRankingMonths(this.form.getRankingMonthContainers(), stats);
        } catch (error) {
            const message = translator.translate("admin_dashboard_load_failed");
            if (statusEl) {
                statusEl.textContent = message;
            }
            notifier.error(message);
            console.error("DashboardHandler load failed", error);
        }
    }
}
